export const fetchPatientsData = async (userId, authToken) => {
    try {
      const response = await fetch("https://x8ki-letl-twmt.n7.xano.io/api:g_BmLeE8/pacientes", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify({ user_id: userId }),
      });
  
      if (!response.ok) throw new Error("Erro ao buscar dados");
  
      return await response.json();
    } catch (error) {
      console.error("Erro ao buscar dados dos pacientes:", error);
      return [];
    }
  };
  